import React from 'react';

function LevelsModal({ onSelectLevel, onClose }) {
  // Number of levels (adjust if you add more levels)
  const TOTAL_LEVELS = 10;
  // Retrieve completed levels from localStorage, default to all false
  const completedLevels = JSON.parse(localStorage.getItem('completedLevels')) || Array(TOTAL_LEVELS).fill(false);

  const handleLevelSelect = (level) => {
    // Allow selection if the level is the first one or the previous level is completed
    if (level === 1 || completedLevels[level - 2]) {
      onSelectLevel(level);
    }
  };

  const handlePlay = () => {
    // Find the first non-completed level
    const lastNonCompletedLevel = completedLevels.findIndex((completed) => !completed) + 1 || TOTAL_LEVELS;
    // Select the last non-completed level if it's selectable
    if (lastNonCompletedLevel === 1 || completedLevels[lastNonCompletedLevel - 2]) {
      onSelectLevel(lastNonCompletedLevel);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-auto">
      <div
        className="bg-gradient-to-b from-[#057CC1] to-[#025F94] p-4 rounded-lg shadow-lg w-11/12 max-w-md max-h-[85vh] relative"
        role="dialog"
        aria-labelledby="levels-modal-title"
      >
        <h2 id="levels-modal-title" className="text-white text-base font-bold mb-4 text-center">
          Levels
        </h2>
        <div className="grid grid-cols-5 gap-4 mb-4">
          {Array.from({ length: TOTAL_LEVELS }, (_, index) => {
            const level = index + 1;
            const isSelectable = level === 1 || completedLevels[level - 2];
            return (
              <button
                key={level}
                onClick={() => handleLevelSelect(level)}
                className={`relative flex items-center justify-center w-12 h-12 transition-all duration-300 ${
                  isSelectable
                    ? 'hover:scale-105 hover:filter hover:drop-shadow-[0_0_12px_rgba(0,255,255,0.6)]'
                    : 'opacity-50 cursor-not-allowed filter grayscale'
                }`}
                disabled={!isSelectable}
                aria-label={`Level ${level}`}
              >
                <img
                  src="/starUi.png"
                  alt={`Level ${level}`}
                  className="w-full h-full object-contain"
                />
                <span className="absolute text-white font-bold text-sm">{level}</span>
              </button>
            );
          })}
        </div>
        <div className="flex items-center justify-center mb-4">
          <button
            onClick={handlePlay}
            className="relative transition-all duration-300 hover:scale-105 hover:filter hover:drop-shadow-[0_0_12px_rgba(0,255,255,0.6)]"
            aria-label="Play last non-completed level"
          >
            <img
              src="/playUi.png"
              alt="Play Button"
              className="w-12 h-12 object-contain"
            />
          </button>
        </div>
        <img
          src="/closeBtn.png"
          alt="Close"
          onClick={onClose}
          className="absolute -top-5 -right-5 w-10 h-10 cursor-pointer hover:opacity-80 transition-opacity duration-300 animate-wobble"
          aria-label="Close levels modal"
        />
      </div>
    </div>
  );
}

export default LevelsModal;